export * from './src/bookings-v2-attendance-attendance.universal.js';
